import React, { useState } from "react";
import { KeyRound, Loader2, X, ShieldCheck } from "lucide-react";
import api, { formatError } from "../lib/api";

export default function PasswordChangeModal({ user, onDone }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (next !== confirm) { setErr("New passwords don't match."); return; }
    if (next.length < 8) { setErr("New password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      onDone?.();
    } catch (e) {
      setErr(formatError(e));
    } finally { setBusy(false); }
  }

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="password-change-modal">
      <form onSubmit={submit} className="bg-white rounded-xl border border-slate-200 w-full max-w-md p-6 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-md bg-amber-100 text-amber-700 grid place-items-center"><KeyRound size={16} /></div>
          <div>
            <h3 className="text-[15px] font-semibold text-slate-900">Change your password</h3>
            <p className="text-[11px] text-slate-500">Welcome {user?.name || user?.erp_id}. Please set a new password to continue.</p>
          </div>
        </div>
        <div>
          <label className="small-caps text-slate-500">Current Password</label>
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="pw-current" />
          <div className="text-[10px] text-slate-400 mt-1">First time? Use the default <code className="bg-slate-100 px-1 rounded">Cbc@2026</code>.</div>
        </div>
        <div>
          <label className="small-caps text-slate-500">New Password</label>
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} data-testid="pw-next" />
        </div>
        <div>
          <label className="small-caps text-slate-500">Confirm New Password</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} data-testid="pw-confirm" />
        </div>
        {err && <div className="tag tag-rose">{err}</div>}
        <button type="submit" disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="pw-submit">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <ShieldCheck size={14} />}
          {busy ? "Saving…" : "Update password"}
        </button>
      </form>
    </div>
  );
}
